var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modern',{attrs:{"hideTopHorizontal":true,"showRight":_vm.showRight}},[_c('MenuCol',{attrs:{"slot":"MenuSider"},slot:"MenuSider"}),_c('router-view',{attrs:{"slot":"ListItem"},slot:"ListItem"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }